import {Component, OnInit, ViewChild} from '@angular/core';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {MessagingService} from '../../../../../core/service/messaging.service';

import * as _ from 'underscore';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {Router} from '@angular/router';
import {ModalService} from 'ngx-dynamic-modal';
import {VnaCampaignCreateComponent} from '../../modals/vna-campaign-create/vna-campaign-create.component';
import {CampOverridedConfigComponent} from '../../modals/camp-overrided-config/camp-overrided-config.component';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';

@Component({
  selector: 'app-list-vna-campaigns',
  templateUrl: './list-vna-campaigns.component.html',
  styleUrls: ['./list-vna-campaigns.component.scss']
})
export class ListVnaCampaignsComponent implements OnInit {

    campaigns: Array<Object> = [];
    temp: Array<Object> = [];
    enabled: boolean = false;
    tableSearchText: string;

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 10;

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private campHandler: VnaCampaignService, private messaging: MessagingService, private auth: AuthService, private router: Router,private modalHandler:ModalService) {

    }

    ngOnInit() {
        this.loadPortalCampaigns();
        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaPortalSelected){
                    this.loadPortalCampaigns();
                }
            }
        )
    };

    isOverrided(portalCampaign: Object): boolean {
        return (_.size(portalCampaign['auth']) + _.size(portalCampaign['config']) > 0);
    }


    navigateActions(row: Object): void {
        this.router.navigateByUrl('phone/config/campaign/' + row['pk_camp'] + '/actions');
    }

    editCampaignConfig(row: Object): void {
        this.router.navigateByUrl('phone/config/campaign/' + row['pk_camp']);
    }

    editCampaign(row: Object): void {
        this.modalHandler.addDynamicComponent(VnaCampaignCreateComponent, row, (res) => {
            if(res){
                this.loadPortalCampaigns();
            }
        });
    }

    navigateCampaign(row: Object): void {
        this.router.navigateByUrl('phone/config/campaign/' + row['pk']);
    }

    seeOverridedConfig(row: Object): void {

        let overridedData = [];
        if(this.isOverrided(row)){
            _.keys(row['config']).forEach( (key) => { overridedData.push(key); });
            _.keys(row['auth']).forEach( (key) => { overridedData.push(key); });
        }

        this.modalHandler.addDynamicComponent(CampOverridedConfigComponent, {'camp' : row['name'], 'overrided_config' : overridedData });
    }

    updateFilter(event) {
        this.tableSearchText = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d['name'].toLowerCase().indexOf(this.tableSearchText) !== -1 || !this.tableSearchText;
        });

        this.campaigns = temp;
    }

    private loadPortalCampaigns(): void {
        this.enabled = true;
        this.campHandler.findPortalCampaignsConfig(this.auth.getPkPortal()).subscribe(
            (result) => {
                this.campaigns = result;
                this.temp = [...result];
                this.endAt = (!this.haveToPaginate()) ? this.campaigns.length : this.perPage;
                this.enabled = false;
            }
        )
    }

    openModal() {
        this.modalHandler.addDynamicComponent(VnaCampaignCreateComponent, {}, (res) => {
            if(res){
                return this.navigateCampaign(res.data);
            }
            this.router.navigateByUrl('phone/config/portal-services');
            })
    }

    goToPage(n: number) {
        this.startAt = (this.pagination) ? this.pagination.getStart() : 0;
        this.endAt = (this.pagination) ? this.pagination.getEnd() : this.perPage;

    }

    haveToPaginate(): boolean {
        return this.perPage < this.campaigns.length;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/list-vna-campaigns/list-vna-campaigns.component.ts